/**
 * "Dinamika": Kremser/NTU usuli turg'un. MODEL_GUIDE 2-band bo'yicha `step` har qadamda
 * `steady` ni chaqiradi va holatga vaqtni yozadi.
 */
import type { StepResult } from '../../types';
import { solveSteady } from './steady';
import type { AbsorberInputs, AbsorberOutputs, AbsorberParams, AbsorberState } from './types';

export function initState(_params: AbsorberParams, _inputs: AbsorberInputs): AbsorberState {
  return { t: 0 };
}

export function stepDynamic(
  params: AbsorberParams,
  state: AbsorberState,
  inputs: AbsorberInputs,
  dt: number,
): StepResult<AbsorberState, AbsorberOutputs> {
  if (!(dt > 0)) throw new Error('absorber: dt must be > 0');
  const r = solveSteady(params, inputs);
  return { state: { t: state.t + dt }, outputs: r.outputs, warnings: r.warnings };
}
